/**
 * Copyright (C) 2022 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import styled from 'styled-components';
import appTheme from '../common/theme/appTheme.json';

/*
Components shared amongst the usage charts 
*/

export const PlaceholderWrapper = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

export const PlaceholderHeading = styled.h2`
  font-family: ${appTheme.viasatFontFamilyRegular};
  font-weight: 800;
  font-size: 18px;
  letter-spacing: 0.2px;
  color: ${appTheme.primaryTextColor};
  display: flex;
  align-items: center;
  text-align: center;
`;

export const PlaceholderText = styled.p`
  font-family: ${appTheme.appFontFamily};
  font-size: 16px;
  color: ${appTheme.secondaryHeaderTextColor};
  display: flex;
  align-items: center;
  text-align: center;
`;
export const StyledNetworkType = styled.h5`
  font-family: ${appTheme.viasatFontFamilyRegular};
  color: #9fafbc;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  margin: 0px;

  @media print {
    color: black;
    margin: 0px;
  }
`;